var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxVectorSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.830078,
    y: 1,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#10141B",
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.958 5.70553C12.1208 5.86825 12.1208 6.13207 11.958 6.29479L7.37471 10.8781C7.21199 11.0408 6.94817 11.0408 6.78545 10.8781L4.70212 8.79479C4.5394 8.63207 4.5394 8.36825 4.70212 8.20554C4.86484 8.04282 5.12865 8.04282 5.29137 8.20554L7.08008 9.99424L11.3688 5.70553C11.5315 5.54282 11.7953 5.54282 11.958 5.70553Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxVectorSelected);
export default __webpack_public_path__ + "static/media/checkboxVectorSelected.54ca109773c08afc5c9b1924b4ceba70.svg";
export { ForwardRef as ReactComponent };